import { ChangeDetectorRef, Component } from '@angular/core';
import { BaseComponent } from '../../../../components/base.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { getCurrentTab, MonitorTab, MonitorTabList } from './monitors.const';
import { NavigationEnd, Router } from '@angular/router';
import { ChatService } from '../../../../common/services/Chat.service';
import { SocketService } from '../../../../common/services/Socket.service';
import { MonitorService } from '../../../../common/services/Monitor.service';
import { SocketActionEnum } from '../../../../common/enums/socket-action.enum';
import * as _ from 'lodash';
import { Role } from '../setting/expert/expert.const';
import * as Sentry from '@sentry/browser';
import { Severity } from '@sentry/browser';

declare const Timer: any;

@Component({
  moduleId: module.id,
  selector: 'monitors',
  templateUrl: './monitors.component.html',
  styleUrls: ['./monitors.component.css'],
})
export class MonitorsComponent extends BaseComponent {
  public dataCall: any;
  public callDaily: any;
  public callList: any = [];
  public dataAgents: any = [];
  public dataAgentDashboard: any;
  public dataCallDashboard: any;
  public timerList: any = [];
  public currentTab = '';
  public tabList = MonitorTabList;
  public ioConnection: any;
  public monitorConnection: any;
  public readonly MonitorTab = MonitorTab;
  private receivedCall: any = {};
  private allCall = [];
  private beExist = [];
  private endedCall = [];
  private getDataInterval: any = null;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    protected router: Router,
    protected chatService: ChatService,
    protected socketService: SocketService,
    protected monitorService: MonitorService
  ) {
    super(changeDetector, toastr, modalService);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentTab = getCurrentTab(event.url);
      }
    });
    this.initIoConnection();
    this.socketListen().then();
  }

  ngOnInit() {
    this.currentTab = getCurrentTab(this.router.url);
    this.loadCall().then(() => {});
    this.getDataInterval = setInterval(() => {
      this.loadCall().then(() => {});
    }, 5000);
    this.socketService.loadCallMonitor();
    this.socketService.loadCallList();
    this.socketService.loadAgentMonitor();
  }

  onChangeTab(tab: any) {
    this.currentTab = tab;
    this.router.navigate([tab]);
    switch (tab) {
      case MonitorTab.ACTIVITIES:
        this.socketService.loadCallMonitor();
        this.socketService.loadCallList();
        break;
      case MonitorTab.CALL_CENTER:
        this.socketService.loadCallMonitor();
        break;
      case MonitorTab.CHANNELS:
        this.socketService.loadCallMonitor();
        break;
      case MonitorTab.AGENTS:
        this.socketService.loadAgentMonitor();
        break;
      case MonitorTab.CALL_MONITOR:
        this.socketService.loadAgentMonitor();
        this.socketService.loadCallList();
        break;
    }
  }

  ///
  createTimerById(id: any, duration: any) {
    // destroy timer
    this.destroyTimerById(id);
    let timer = new Timer();
    timer.start({ precision: 'seconds', startValues: { seconds: duration } });
    timer.addEventListener('secondsUpdated', function (e) {
      $('#' + id).html(timer.getTimeValues().toString());
    });
    this.timerList.push({ id: id, timer: timer });
  }

  destroyTimerById(id: any) {
    let index = -1;
    for (let i = 0; i < this.timerList.length; i++) {
      if (this.timerList[i] && this.timerList[i].id == id) {
        index = i;
        this.destroyTimer(this.timerList[i].timer);
        break;
      }
    }
    if (index != -1) {
      this.timerList.splice(index, 1);
    }
  }

  destroyAllTimers() {
    for (let i = 0; i < this.timerList.length; i++) {
      this.destroyTimer(this.timerList[i].timer);
    }
    this.timerList = [];
  }

  createAllTimers() {
    this.destroyAllTimers();
    for (let i = 0; i < this.callList.length; i++) {
      this.createTimerById(this.callList[i].callId, this.callList[i].duration);
    }
  }

  destroyTimer(timer: any) {
    timer.stop();
  }

  async loadCall() {
    const tenantId = this.user.tenant_id;
    this.monitorService.getCallDaily(tenantId).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.callDaily = res.data;
      }
    });
    this.monitorService.getInqueueEmails(tenantId).subscribe(res => {
      let totalEmailWaiting = 0;
      if (res.status == 200 && !res.error) {
        totalEmailWaiting = res.data;
      }
      this.monitorService.call().subscribe(res => {
        if (res.status == 200 && !res.error) {
          let data = res.data;
          data.analytic.totalEmailWaiting = totalEmailWaiting;
          this.dataCall = data;
        }
      });
    });
  }

  ///

  ngOnDestroy() {
    this.ioConnection.unsubscribe();
    this.monitorConnection.unsubscribe();
    if (this.getDataInterval) {
      clearInterval(this.getDataInterval);
    }
  }

  private initIoConnection() {
    this.ioConnection = this.chatService.onUpdateMonitor().subscribe((message: any) => {
      this.loadCall().then();
      console.log('monitor', message);
    });
    this.chatService.onEvent('connect').subscribe(() => {
      console.log('connected');
    });
    this.chatService.onEvent('disconnect').subscribe(() => {
      console.log('disconnected');
    });
  }

  private async socketListen() {
    const throttledHandler = _.throttle(mission => {
      this.processMission(mission);
    }, 1000); // Throttle the function to run at most once every second
    this.monitorConnection = this.socketService.missionAnnounced$.subscribe(mission => {
      throttledHandler(mission);
    });
  }

  private processMission(mission: any) {
    switch (mission.action) {
      case SocketActionEnum.UPDATE_MONITOR:
        this.loadCall().then();
        break;
      case SocketActionEnum.UPDATE_MONITOR_CALL:
        this.dataCallDashboard = mission.data;
        break;
      case SocketActionEnum.UPDATE_MONITOR_AGENT_DASHBOARD:
        this.dataAgentDashboard = mission.data;
        break;
      case SocketActionEnum.UPDATE_MONITOR_CALL_LIST:
        this.callList = mission.data.filter(data => data.status != 'END_CALL');
        this.createAllTimers();
        break;
      case SocketActionEnum.UPDATE_MONITOR_CALL_DETAIL:
        let agentCalls = mission.data;

        if (Array.isArray(agentCalls) && agentCalls.length > 0) {
          const callInfo = agentCalls[0];
          this.receivedCall[callInfo.callId] = callInfo.status;
          if (!this.allCall.includes(callInfo.callId)) {
            this.allCall.push(callInfo.callId);
          }
          const exist = this.callList.find(call => call.callId === callInfo.callId);
          if (!exist) {
            this.callList = this.callList.filter(call => call.username !== callInfo.username);
            this.callList.push(callInfo);
          } else {
            this.callList = this.callList.map(call => {
              if (call.callId === callInfo.callId) {
                return callInfo;
              }
              return call;
            });
          }
          this.callList = this.callList.filter(data => data.status != 'END_CALL');
          this.socketService.loadAgentMonitor();
          this.createTimerById(callInfo.callId, callInfo.duration);
          // this.loadCall().then();
        }
        break;
      case SocketActionEnum.UPDATE_MONITOR_CALL_DETAIL_END:
        const callId = mission.data;
        // Sentry.captureMessage(`[CALL_INFO][${callId}]====>[STATUS][END_CALL]`, Severity.Info)
        this.receivedCall[callId] = 'END_CALL';
        this.endedCall.push(callId);
        this.callList = this.callList.filter(data => data.callId !== callId && data.status != 'END_CALL');
        this.socketService.loadAgentMonitor();
        this.destroyTimerById(callId);
        // this.loadCall().then();
        break;
      case SocketActionEnum.UPDATE_MONITOR_ALL_AGENT:
        const agents = mission.data.agents;
        const validAgent = agents.filter(r => r.status !== 'LOGOUT');
        if (JSON.stringify(this.dataAgents) !== JSON.stringify(validAgent)) {
          this.dataAgents = validAgent;
        }
        if (this.user.role === Role.TeamLeader) {
          this.dataAgents = this.dataAgents.filter(d => d.groupId == this.user.group_id);
        }
        break;
      case SocketActionEnum.UPDATE_MONITOR_AGENT:
        if (mission.data.status === 'LOGOUT') {
          this.dataAgents = this.dataAgents.filter(item => item.username !== mission.data.username);
        } else {
          const isExisted = this.dataAgents.find(item => item.username === mission.data.username);
          if (!isExisted) {
            this.dataAgents.push(mission.data);
          } else {
            this.dataAgents = this.dataAgents.map(agent => {
              if (agent.username == mission.data.username) {
                agent.status = mission.data.status;
                agent.facebookStatus = mission.data.facebookStatus;
                agent.chatStatus = mission.data.chatStatus;
                agent.emailStatus = mission.data.emailStatus;
                agent.zaloStatus = mission.data.zaloStatus;
                agent.systemStatus = mission.data.systemStatus
                  ? mission.data.systemStatus
                  : mission.data.statusType
                    ? 'AVAILABLE'
                    : 'NOT AVAILABLE';
              }
              return agent;
            });
          }
        }
        break;
      case SocketActionEnum.UPDATE_MONITOR_AGENT_PHONE_TYPE:
        const isExisted = this.dataAgents.find(item => item.username === mission.data.username);
        if (isExisted) {
          this.dataAgents = this.dataAgents.map(agent => {
            if (agent.username == mission.data.username) {
              agent.phoneType = mission.data.phoneType;
            }
            return agent;
          });
        }
        break;
      default:
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/monitors/monitors.component.ts